export const HttpFetchClient = (
  baseURL,
  requestInterceptor = request => request,
  responseInterceptor = response => response.data,
  errorHandler = error => Promise.reject(error),
) => {
  const get = async (path) => {
    const response = await instanceResponse(baseURL, path, 'GET');
    return response;
  }
  
  const put = async (path, body) => {
    const response = await instanceResponse(baseURL, path, 'PUT', body);
    return response;
  }


  const post = async (path, body) => {
    const response = await instanceResponse(baseURL, path, 'POST', body);
    return response;
  }

  const postFormData = async (path, body) => {
    const response = await instancePostResponse(baseURL, path, 'POST', body);
    return response;
  }

  const instanceResponse = async (baseURL, path, method, body) => {
    const request = buildReqest(baseURL, path, method, body);
    const response = await fetch(request);
    const data = await response ? response?.json() : {};

    return data;
  }

  const instancePostResponse = async (baseURL, path, method, body) => {
    const request = buildReqestFormData(baseURL, path, method, body);
    const response = await fetch(request);
    const data = await response ? response?.json() : {};

    return data;
  }

  const buildReqestFormData = (baseURL, uri, method, body) => {
    return new Request(`${baseURL}${uri}`, {
      method: method,
      body: body,
      redirect: 'follow'
    });
  }

  const buildReqest = (baseURL, uri, method, body) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    return new Request(`${baseURL}${uri}`, {
      method: method,
      body: JSON.stringify(body),
      headers: myHeaders,
      redirect: 'follow'
    });
  }

  return {
    get,
    post,
    postFormData,
    put
  }
};